export enum Theme {
  Light = "light",
  Dark = "dark",
}
